import React from "react";
import firebase from "./../Firebase.js";
// eslint-disable-next-line no-unused-vars
import Button from "@material-ui/core/Button";
// eslint-disable-next-line no-unused-vars
import TextField from "@material-ui/core/TextField";
// eslint-disable-next-line no-unused-vars
import Dialog from "@material-ui/core/Dialog";
// eslint-disable-next-line no-unused-vars
import DialogActions from "@material-ui/core/DialogActions";
// eslint-disable-next-line no-unused-vars
import DialogContent from "@material-ui/core/DialogContent";
// eslint-disable-next-line no-unused-vars
import DialogTitle from "@material-ui/core/DialogTitle";
import UpdateCommunityLocation from "../../functions/UpdateCommunityLocation.js";
// eslint-disable-next-line no-unused-vars
import Switch from "@material-ui/core/Switch";
// eslint-disable-next-line no-unused-vars
import FormControlLabel from "@material-ui/core/FormControlLabel";

export default class AnnouncementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      announcementOn: props.announcementOn,
      announcementTitle: props.announcementTitle,
      announcementDescription: props.announcementDescription,
      announcementImage: props.announcementImage,
      announcementWebsite: props.announcementWebsite,
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClickOpen() {
    this.setState({
      open: true,
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  handleFocus = (event) => event.target.select();

  handleSave(e) {
    e.preventDefault();
    const database = firebase.firestore();
    const batch = database.batch();
    // NEEDS WORK I need to correct the fact that it only looks at Vancouver
    const distributionLocationsDocRef = database
      .collection("DistributionLocations")
      .doc("Vancouver");
    const userInfo = this.props.userInfo;

    if (userInfo.userType === "distributionLocation") {
      batch.update(distributionLocationsDocRef, {
        [[userInfo.organisationName, "announcementOn"].join(".")]:
          this.state.announcementOn,
        [[userInfo.organisationName, "announcementTitle"].join(".")]:
          this.state.announcementTitle,
        [[userInfo.organisationName, "announcementDescription"].join(".")]:
          this.state.announcementDescription,
        [[userInfo.organisationName, "announcementImage"].join(".")]:
          this.state.announcementImage,
        [[userInfo.organisationName, "announcementWebsite"].join(".")]:
          this.state.announcementWebsite,
      });
      // Updates any community locations that may exist that have this distribution location as their partner.
      UpdateCommunityLocation(
        userInfo.userId,
        {},
        false,
        false,
        this.state,
        false,
        true,
      );
      batch.commit();
    }

    this.setState({
      open: false,
    });
    this.props.handleInfoUpdate(this.state);
  }

  handleChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    // If the announcementOn is the change trigger then we want to
    // set the boolean otherwise it's just the value the user entered.
    if (name === "announcementOn") {
      this.setState({
        announcementOn: !this.state.announcementOn,
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  }

  render() {
    return (
      <div>
        <Button
          className="Edit-Button"
          variant="outlined"
          color="primary"
          onClick={this.handleClickOpen}
        >
          edit
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="form-dialog-title"
            style={{ padding: "16px 24px 0px" }}
          >
            Create an Announcement
          </DialogTitle>
          <DialogContent>
            <form onSubmit={this.handleSave}>
              <FormControlLabel
                label="Show Announcement"
                control={
                  <Switch
                    checked={this.state.announcementOn}
                    name="announcementOn"
                    onChange={this.handleChange}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                }
              />
              <TextField
                margin="dense"
                id="announcement title"
                label="Announcement title"
                name="announcementTitle"
                value={this.state.announcementTitle}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                fullWidth
                required
              />
              <TextField
                margin="dense"
                id="announcement description"
                label="Description of event or announcement"
                name="announcementDescription"
                value={this.state.announcementDescription}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                multiline
                fullWidth
                required
              />
              <TextField
                margin="dense"
                id="announcement image"
                label="Image of poster or flyer (if applicable)"
                name="announcementImage"
                value={this.state.announcementImage}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                fullWidth
              />
              <TextField
                margin="dense"
                id="announcement website"
                label="Announcement website (if applicable)"
                name="announcementWebsite"
                value={this.state.announcementWebsite}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                fullWidth
              />

              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button type="submit" color="primary">
                  Save
                </Button>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
